<template>
  <div class="contact" :style="contactStyleObj" v-if="landscape">
    <div class="btn-close" @click="routeTo('Dashboard')"></div>
    <div class="banner">
      <img src="../assets/banner_contact_us.png" v-animate-css="slideInObject" alt="">
    </div>
    <div class="covers">
      <div class="top"></div>
      <div class="left"></div>
      <div class="bottom"></div>
      <div class="right"></div>
    </div>
    <div class="pic">
      <img src="../assets/pic_contact.jpg" v-animate-css="fadeInObject" alt="">
    </div>
    <div class="text">
      <img src="../assets/text_contact.png" v-animate-css="fadeInRight" alt="">
      <a class="email-link" href="mailto:hello@blackbeanssoft.com"></a>
      <a href="tel:0532-80916071" class="phone-link"></a>
    </div>
  </div>
  <div class="contact-portrait" :style="contactStyleObj" v-else>
    <div class="btn-close" @click="routeTo('Dashboard')"></div>
    <div class="banner">
      <img src="../assets/banner_contact_us.png" v-animate-css="slideInObject" alt="">
    </div>
    <div class="covers">
      <div class="top"></div>
      <div class="left"></div>
      <div class="bottom"></div>
      <div class="right"></div>
    </div>
    <div class="wrapper">
      <div class="text">
        <img src="../assets/text_contact.png" v-animate-css="fadeInRight" alt="">
        <a class="email-link" href="mailto:hello@blackbeanssoft.com"></a>
        <a href="tel:0532-80916071" class="phone-link"></a>
      </div>
      <div class="pic">
        <img src="../assets/pic_contact.jpg" v-animate-css="fadeInObject" alt="">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      contactStyleObj: {
        width: window.innerWidth - 1 * window.innerWidth / 17 + 'px',
        height: window.innerHeight - 1 * window.innerWidth / 17 + 'px',
        marginTop: '0.5rem'
      },
      slideInObject: {
        classes: 'slideInLeft',
        delay: 2000
      },
      fadeInObject: {
        classes: 'fadeIn',
        delay: 2000
      },
      fadeInRight: {
        classes: 'fadeInRight',
        delay: 2000
      }
    }
  },
  props: ['landscape'],
  components: {
  },
  mounted () {
    const self = this
    this.setWidth()
    window.addEventListener('resize', function () {
      self.setWidth()
    })
  },
  methods: {
    setWidth: function () {
      if (this.landscape) {
        this.contactStyleObj = {
          width: window.innerWidth - 1 * window.innerWidth / 17 + 'px',
          height: window.innerHeight - 1 * window.innerWidth / 17 + 'px',
          marginTop: '0.5rem'
        }
      } else {
        this.contactStyleObj = {
          width: window.innerWidth - 1 * window.innerWidth / 8 + 'px',
          height: window.innerHeight - 1 * window.innerWidth / 8 + 'px',
          marginTop: '0.5rem'
        }
      }
    },
    routeTo: function (name) {
      this.$router.push('/')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../Global.scss';
.contact {
  border: .01rem solid #000;
  position: relative;
  .btn-close {
    width: .5rem;
    height: .5rem;
    position: absolute;
    right: -.25rem;
    top: -.25rem;
    background-color: white;
    background-image: url('../assets/icon_close_large.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: .19rem .19rem;
    z-index: 999;
    cursor: pointer;
    transform: rotate(-45deg);
    animation: rotate .5s 2s linear forwards;
    &:hover {
      background-size: .20rem .20rem;
    }
  }
  .banner {
    height: 80%;
    @extend .verticalAlignMiddle;
    overflow: hidden;
    img {
      height: 100%;
    }
  }
  .covers {
    .top
    {
      width: 100%;
      height: .02rem;
      position: absolute;
      background: white;
      top: -.01rem;
      right: 0;
      animation: widthFold .5s 1.5s linear forwards;
    }
    .left {
      height: 100%;
      width: .02rem;
      position: absolute;
      left: -.01rem;
      top: 0;
      background: white;
      animation: heightFold .5s 1s linear forwards;
    }
    .bottom {
      @extend .top;
      top: auto;
      bottom: -.01rem;
      left: 0;
      animation: widthFold .5s .5s linear forwards;
    }
    .right {
      @extend .left;
      left: auto;
      right: -.01rem;
      top: auto;
      bottom: 0;
      animation: heightFold .5s linear forwards;
    }
  }
  > .pic {
    height: 30%;
    img {
      height: 100%;
    }
    @extend .verticalAlignMiddle;
    left: -.5rem;
  }
  > .text {
    height: 50%;
    @extend .verticalAlignMiddle;
    left: 4rem;
    .email-link {
      width: 60%;
      height: .5rem;
      display: block;
      position: absolute;
      top: 3.05rem;
      opacity: 0;
      background: gray;
    }
    .phone-link {
      width: 30%;
      height: .5rem;
      display: block;
      position: absolute;
      top: 2.1rem;
      opacity: 0;
      background: gray;
    }
    img {
      height: 100%;
    }
  }
}

.contact-portrait {
  @extend .contact;
  .wrapper {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    @include flexBox(column, nowrap, center, center);
    .text {
      width: 60%;
      position: relative;
      .email-link {
        width: 55%;
        height: .25rem;
        display: block;
        position: absolute;
        top: 2.35rem;
        opacity: 0;
      }
      .phone-link {
        width: 30%;
        height: .25rem;
        display: block;
        position: absolute;
        top: 1.6rem;
        opacity: 0;
      }
      img {
        width: 100%;
        height: auto;
      }
    }
    .pic {
      width: 60%;
      img {
        width: 100%;
      }
    }
  }
  
}
@keyframes heightFold {
  from {
    height: 100%;
  }
  to {
    height: 0%;
  }
}
@keyframes widthFold {
  from {
    width: 100%;
  }
  to {
    width: 0%;
  }
}
@keyframes rotate {
  from {
    transform: rotate(-45deg)
  }
  to {
    transform: rotate(90deg)
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Contact.vue